import { render } from "./Licenses.vue?vue&type=template&id=11eb3080&scoped=true&ts=true"
import script from "./Licenses.vue?vue&type=script&lang=ts"
export * from "./Licenses.vue?vue&type=script&lang=ts"

import "./Licenses.vue?vue&type=style&index=0&id=11eb3080&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11eb3080"]])

export default __exports__